/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateLocationRequestDto,
  CreateLocationResponseDto,
  DomainErrorDto,
  GetLocationFilterColumnsResponseDto,
  GetLocationsResponseDto,
  LocationControllerGetLocationsParams
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType , BodyType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const locationControllerGetLocations = (
    params?: LocationControllerGetLocationsParams,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetLocationsResponseDto>(
      {url: `/api/v1/account/location`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLocationControllerGetLocationsQueryKey = (params?: LocationControllerGetLocationsParams,) => {
    return [
    `/api/v1/account/location`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationControllerGetLocationsQueryOptions = <TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationControllerGetLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationControllerGetLocations>>> = ({ signal }) => locationControllerGetLocations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationControllerGetLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof locationControllerGetLocations>>>
export type LocationControllerGetLocationsQueryError = ErrorType<DomainErrorDto>


export function useLocationControllerGetLocations<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  LocationControllerGetLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationControllerGetLocations>>,
          TError,
          Awaited<ReturnType<typeof locationControllerGetLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocations<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationControllerGetLocations>>,
          TError,
          Awaited<ReturnType<typeof locationControllerGetLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocations<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationControllerGetLocations<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationControllerGetLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getLocationControllerGetLocationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationControllerGetLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationControllerGetLocations>>> = ({ signal }) => locationControllerGetLocations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationControllerGetLocationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof locationControllerGetLocations>>>
export type LocationControllerGetLocationsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useLocationControllerGetLocationsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  LocationControllerGetLocationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocationsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocationsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationControllerGetLocationsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocations>>, TError = ErrorType<DomainErrorDto>>(
 params?: LocationControllerGetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationControllerGetLocationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const locationControllerCreateLocation = (
    createLocationRequestDto: BodyType<CreateLocationRequestDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<CreateLocationResponseDto>(
      {url: `/api/v1/account/location`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLocationRequestDto, signal
    },
      options);
    }



export const getLocationControllerCreateLocationMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationControllerCreateLocation>>, TError,{data: BodyType<CreateLocationRequestDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof locationControllerCreateLocation>>, TError,{data: BodyType<CreateLocationRequestDto>}, TContext> => {

const mutationKey = ['locationControllerCreateLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationControllerCreateLocation>>, {data: BodyType<CreateLocationRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  locationControllerCreateLocation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationControllerCreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof locationControllerCreateLocation>>>
    export type LocationControllerCreateLocationMutationBody = BodyType<CreateLocationRequestDto>
    export type LocationControllerCreateLocationMutationError = ErrorType<DomainErrorDto>

    export const useLocationControllerCreateLocation = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationControllerCreateLocation>>, TError,{data: BodyType<CreateLocationRequestDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationControllerCreateLocation>>,
        TError,
        {data: BodyType<CreateLocationRequestDto>},
        TContext
      > => {
      return useMutation(getLocationControllerCreateLocationMutationOptions(options), queryClient);
    }
    export const locationControllerGetLocationFilterColumns = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetLocationFilterColumnsResponseDto>(
      {url: `/api/v1/account/location/filter-columns`, method: 'GET', signal
    },
      options);
    }




export const getLocationControllerGetLocationFilterColumnsQueryKey = () => {
    return [
    `/api/v1/account/location/filter-columns`
    ] as const;
    }


export const getLocationControllerGetLocationFilterColumnsQueryOptions = <TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationControllerGetLocationFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>> = ({ signal }) => locationControllerGetLocationFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationControllerGetLocationFilterColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>>
export type LocationControllerGetLocationFilterColumnsQueryError = ErrorType<DomainErrorDto>


export function useLocationControllerGetLocationFilterColumns<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocationFilterColumns<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocationFilterColumns<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationControllerGetLocationFilterColumns<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationControllerGetLocationFilterColumnsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getLocationControllerGetLocationFilterColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationControllerGetLocationFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>> = ({ signal }) => locationControllerGetLocationFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationControllerGetLocationFilterColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>>
export type LocationControllerGetLocationFilterColumnsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useLocationControllerGetLocationFilterColumnsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocationFilterColumnsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationControllerGetLocationFilterColumnsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationControllerGetLocationFilterColumnsSuspense<TData = Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof locationControllerGetLocationFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationControllerGetLocationFilterColumnsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






